import {mapGetters} from 'vuex'
import store from '../store'
// import config from "@/config"
export default {
	install(Vue){
		
		//转换成数字
		Vue.filter('num', function(v){
			return Number(v);
		})
		
		
		Vue.mixin({
			data(){
				return {
					// imgurl: config.web_url+'/static/xcx/',
				}
			},
			computed:{
				...mapGetters(['token','userInfo','infoTitle','pageShow','mingcheng'])
			},
			methods:{
				isLogin(){ //验证是否登录
					let token = store.getters.token;//getApp().globalData.token;
					return token ? true : false;
				},
				// href(url,isTab = false){ //跳转方法
				// 	if(isTab){
				// 		if(!this.isLogin() && ['/pages/cart','/pages/my'].indexOf(url) != -1){
				// 			uni.setStorageSync('login_href', url);
				// 			uni.navigateTo({
				// 				url: '/pages/index/login'
				// 			})
				// 			return;
				// 		}
				// 		uni.switchTab({
				// 			url: url
				// 		});
				// 	}else{
				// 		uni.navigateTo({
				// 			url:url,
				// 		})
				// 	}
				// },
				// back(){ //返回方法
				// 	let pages = getCurrentPages();
				// 	if(pages.length == 1){
				// 		uni.switchTab({
				// 			url: '/pages/index',
				// 		});
				// 	}else{
				// 		uni.navigateBack();
				// 	}
				// },
				// numEdit(state,name){ //模板快捷数字加减
				// 	if(!state && this[name] <= 1) return;
				// 	this[name] += (state) ? 1 : -1;
				// },
				// setVal(k,v){ //模板快捷设置data
				// 	k = k.split('.');
				// 	let thisK = this;
				// 	for( let i=0; i<k.length-1; i++){
				// 		thisK = thisK[ k[i] ];
				// 	}
				// 	this.$set(thisK, k[k.length-1], v);
				// }, 
				// copy(val){ //复制内容到剪切板
				// 	uni.setClipboardData({
				// 		data: val,
				// 		showToast: false,
				// 		success:()=>{
				// 			uni.showToast({
				// 				title:'复制成功！',
				// 				icon:'none'
				// 			});
				// 		}
				// 	})
				// },
				// openWeb(url){
				// 	uni.setStorageSync('web_url',url);
				// 	this.href('/pages/index/web');
				// }
			}
		});
		
		

	}
}


// WEBPACK FOOTER //
// ./src/utils/use.js